/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddressItem/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import City from './City/index'
import React from 'react'
import Remove from './Remove/index'
import State from './State/index'
import Street from './Street/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import Zip from './Zip/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AddressItem({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Addresses/AddressItem"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="AddressItem.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-kWNln': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="AddressItem.Vertical"
  data-view-path={viewPath}
 style={{'--pr-2-kWNln': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Street
  viewPath={`${viewPath}/Street`}
/>
<State
  viewPath={`${viewPath}/State`}
/>
</div>
<div
  data-testid="AddressItem.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<City
  viewPath={`${viewPath}/City`}
/>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
</div>
<Remove
  viewPath={`${viewPath}/Remove`}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral200}
/>
{children}
</React.Fragment>)
}